import { picoapp } from 'picoapp';
import srraf from 'srraf';
import components from './components';
import modal from 'micromodal';
import load from './polyfills';

load(() => {

  const html = document.documentElement;
  const header = document.querySelector('.site-header');

  srraf(() => {
    html.style.setProperty('--ui-header-height', `${header.offsetHeight}px`);
  }).update();

  modal.init({
    openTrigger: 'data-modal',
    closeTrigger: 'data-modal-close',
    awaitOpenAnimation: true,
    awaitCloseAnimation: true
  });

  const app = picoapp(components);

  app.use(node => {
    const props = JSON.parse(node.dataset.props || '{}');
    return { props };
  });

  app.mount();

});